<template>
    <div>
        <app-form v-if="dataLoaded"
            v-bind:parentObject = "{
                data: this.formData,
                dataParameter: this.formDataParameter,
                parameters: this.parameters,
                staffList: this.staffList,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode,
                isWizard: this.isWizard
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import moment from 'moment';
import KpiSettingForm from '../../../components/performance/reviewexercise/Form_Staff';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': KpiSettingForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('pmreviewexercise.generateappraisalexercise'),
            pageTitleValue: this.$route.params.formData.reviewcode,

            formData: {
                ...this.$route.params.formData,
                totalRecords: null
            },
            formDataParameter: this.$route.params.formDataParameter,
            parameters: this.$route.params.parameters,      
            staffList: [],      

            errMsg: '',
            isErr:false,
            editMode: false,
            isWizard: true,
            dataLoaded: false,
        }
    },
    methods: {
        async loadGenerateStaff() {

            const vm = this;

            // Dispatch the post request with the payloads object
            await this.$store.dispatch('get', {url: "/reviewexercise/staff/" + vm.formData.pmreviewexerciseid})
            .then((res) => {

            if (res.status == 200) {

                for (let i = 0; i < res.data.rec.length; i++) {

                    if (res.data.rec[i].startdate) {
                        res.data.rec[i].startdate = moment(res.data.rec[i].startdate).format('YYYY-MM-DD');
                    }

                    if (res.data.rec[i].enddate) {
                        res.data.rec[i].enddate = moment(res.data.rec[i].enddate).format('YYYY-MM-DD');
                    }

                }

                vm.staffList = res.data.rec;
                console.log("Staff List: ", vm.staffList);
                vm.formData.totalRecords = res.data.rec.length;

            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log("This error is ", err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },
    },

    async created() {
        await this.loadGenerateStaff();
        this.dataLoaded = true; 
    }

}

</script>